import { useMemo } from 'react';
import { InsuranceProductSortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): InsuranceProductSortingField => {
    switch (field) {
        case 'module.company.displayName':
            return InsuranceProductSortingField.Company;

        case 'displayName':
            return InsuranceProductSortingField.DisplayName;

        case 'identifier':
            return InsuranceProductSortingField.Identifier;

        case 'insurer.legalName.defaultValue':
            return InsuranceProductSortingField.Insurer;

        case 'order':
            return InsuranceProductSortingField.Order;

        case 'legalName.defaultValue':
            return InsuranceProductSortingField.LegalName;

        case 'description.defaultValue':
            return InsuranceProductSortingField.Description;

        case 'isActive':
            return InsuranceProductSortingField.IsActive;

        case 'period.start':
            return InsuranceProductSortingField.StartDate;

        case 'period.end':
            return InsuranceProductSortingField.EndDate;

        case 'type':
            return InsuranceProductSortingField.Type;

        default:
            throw new Error(`Unknown Sorting Field! Field: ${field}`);
    }
});

const useSortOrder = sort =>
    useMemo(
        () => ({
            companySort: sort.field === InsuranceProductSortingField.Company ? sort.orderValue : undefined,
            displayNameSort: sort.field === InsuranceProductSortingField.DisplayName ? sort.orderValue : undefined,
            legalNameSort: sort.field === InsuranceProductSortingField.LegalName ? sort.orderValue : undefined,
            identifierSort: sort.field === InsuranceProductSortingField.Identifier ? sort.orderValue : undefined,
            insurerNameSort: sort.field === InsuranceProductSortingField.Insurer ? sort.orderValue : undefined,
            orderSort: sort.field === InsuranceProductSortingField.Order ? sort.orderValue : undefined,
            descriptionSort: sort.field === InsuranceProductSortingField.Description ? sort.orderValue : undefined,
            activeSort: sort.field === InsuranceProductSortingField.IsActive ? sort.orderValue : undefined,
            startDateSort: sort.field === InsuranceProductSortingField.StartDate ? sort.orderValue : undefined,
            endDateSort: sort.field === InsuranceProductSortingField.EndDate ? sort.orderValue : undefined,
            typeSort: sort.field === InsuranceProductSortingField.Type ? sort.orderValue : undefined,
        }),
        [sort]
    );

export default useSortOrder;
